var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classes,on:{"click":function($event){$event.stopPropagation();return _vm.select.apply(null, arguments)},"mousedown":function($event){$event.preventDefault();}}},[(_vm.overflow)?_c('div',{staticStyle:{"overflow":"hidden","text-overflow":"ellipsis","word-break":"keep-all","white-space":"nowrap"},style:({
            width: _vm.parentWidth + 'px'
        })},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.showLabel))]})],2):_vm._t("default",function(){return [_vm._v(_vm._s(_vm.showLabel))]})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/select/option.vue